import * as React from "react";
import { Route, Switch } from "react-router-dom";
import { withRouter } from "react-router";
import { RouterWrap } from "@mc/react-app-v4";
import { HomePage } from "./pages/HomePage";
import { SoudniSporDetailPage } from "./pages/SoudniSporDetailPage";
import { VyhledavaniPage } from "./pages/VyhledavaniPage";
import { ZBOPage } from "@mc/zbo-connector";

type Props = {};

const App: React.FC<Props> = () => {
  return (
    <RouterWrap loginPageProps={{ appTitle: "AA - Soudní spory" }}>
      <Route exact path={"/soudni-spory"} component={HomePage} />
      <Route path={"/soudni-spory/seznam"} component={VyhledavaniPage} />
      <Route
        exact
        path={"/soudni-spory/detail"}
        component={SoudniSporDetailPage}
      />
      <Route path={"/zbo-app/:pripadId?"} component={ZBOPage} />
    </RouterWrap>
  );
};

export default withRouter(App);
